<template>
    <section id="about" class="about container main">
        <div class="wrapper main">
          <h2 data-aos="fade-up"><SvgTitle /><caption>MISSION LEADS IDEA</caption></h2>
          <div class="inner">
              <div class="box" data-aos="fade-up">
                  <span class="point"><Movie /></span>
                  <span class="point"><Music /></span>
                  <span class="point"><Event /></span>
                  <span class="point"><Model /></span>
                  <div class="box-gradient">
                      <div class="gradient"></div>
                      <div class="cover">
                          <img src="@/assets/img/tx1.jpg">
                      </div>
                  </div>
                  <div class="logomark">
                    <Wordmark class="wordmark" />
                  </div>
              </div>
          </div>
          <div class="inner paragraph" data-aos="fade-up">
            <p>
              QUAD PRODUCTIONは、4つのコンテンツを軸に世の中を良くしたいという想いで設立しました。
              もともとは、イギリスのレコーディングミキサーSSLに搭載されたコンプレッサー名から来ており、
              このQUADコンプが生み出すマッスルサウンドは凄く、ダンスミュージックのプロ集団事務所として命名しました。
            </p>
          </div>
          <div class="inner service paragraph">
             <h2 data-aos="fade-up service"><ServiceTitle /><caption>SERVICE</caption></h2> 
             <ul>
                <li><p>テレビCM、ラジオCM、<br class="hidePc">プロモーションビデオ、<br class="hidePc">ミュージックビデオなどの企画、制作</p></li>
                <li><p>コマソン、社歌、<br class="hidePc">オリジナル店内BGMなどの音楽制作</p></li>
                <li><p>新聞広告、雑誌広告、ポスター、<br class="hidePc">店頭ツールなどグラフィック広告の企画、制作</p></li>
                <li><p>ウェブサイトなどの企画・<br class="hidePc">制作及びウェブ広告の企画、制作</p></li>
                <li><p>CI、BI、VIの企画、制作</p></li>
                <li><p>広告キャンペーンの企画、立案及び、<br class="hidePc">ブランディングなどに関わるスーパーバイズ業務</p></li>
                <li><p>企業理念、商品、<br class="hidePc">サービスなどのコンセプト開発</p></li>
                <li><p>ネーミング・ロゴ・キャッチフレーズ・<br class="hidePc">キャラクターなどの企画、制作</p></li>
                <li><p>パッケージデザイン・<br class="hidePc">サインデザインなどの企画、制作</p></li>
                <li><p>屋内外のイベントの企画、制作</p></li>
                <li><p>モデル、タレントなどのマネージメント<br class="onlySp">及びキャスティング</p></li>
             </ul>
          </div>
        </div>    
    </section>
</template>

<script>
import SvgTitle from '@/assets/icon/h2/about.svg?inline'
import ServiceTitle from '@/assets/icon/h2/service.svg?inline'
import Wordmark from '@/assets/icon/wordmark.svg?inline'
import Movie from '@/assets/icon/h2/about_movie.svg?inline'
import Music from '@/assets/icon/h2/about_music.svg?inline'
import Event from '@/assets/icon/h2/about_event.svg?inline'
import Model from '@/assets/icon/h2/about_model.svg?inline'

export default {
  name: 'About',
  components: {
      SvgTitle,
      ServiceTitle,
      Wordmark,
      Movie,
      Music,
      Event,
      Model,
  },
  data(){
      return{
          
      }
  },
  created(){
      
  },
  mounted(){
      
  },
  methods: {
      
  }
}
</script>

<style lang="scss">
#about{
    .wrapper{
        .inner{
            padding: 21px 0 0;
            &.paragraph{
                padding: 72px 0 0;
                    p{
                        width: 100%;
                        display: block;
                    }
                @media #{$maxM}{
                    padding: $sp-padding 0 0;
                }
            }
            &.service{
                justify-content: flex-start;
                align-items: flex-start;
                h2{
                    height: 1.25rem;
                    line-height: 0;
                    display: block;
                    width: 100%;
                    margin: 0;
                    margin-bottom: 20px;
                    @media #{$maxM}{
                        margin-bottom: 10px;
                    }
                    
                        svg{
                            padding: 0.125rem 0;
                            height: calc(100% - 0.25rem);
                            width: auto;
                            @media #{$maxM}{
                                height: 10px;
                            }
                        }
                    @media #{$IE}{
                        width: 93px;
                    }
                }
                ul{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    margin: 0;
                    li{
                        display: flex;
                        justify-content: flex-start;
                        align-items: stretch;
                        flex-flow: row nowrap;
                        margin-bottom: .2em;
                        word-break: normal;
                        -webkit-word-brak: break-all;
                            &:last-child{
                                margin-bottom: 0;
                            }
                        @media #{$maxM}{
                            margin-bottom: 1.2em;
                            &:last-child{
                                margin-bottom: 0;
                            }
                        }
                        p{
                            width: 100%;
                            text-align: left;
                            overflow-wrap: break-word;
                        }
                        &::before{
                            content: '・';
                            position: relative;
                            height: 100%;
                            margin-top: 0.75em;
                            @media #{$maxM}{
                                margin-top: 0.42em;
                            }
                        }
                    }
                }
            }
            .box{
                display: block;
                position: relative;
                width: 41.4vw;
                max-width: 460px;
                height: 41.4vw;
                max-height: 460px;
                margin-top: 15px;
                margin-bottom: 15px;
                @media #{$maxS}{
                    width: 46.9333vw;
                    height: 46.9333vw;
                }
                .box-gradient{
                    transform: rotate(90deg);
                }
                .gradient{
                    width: 140%;
                    height: 140%;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
                .cover{
                    z-index: -1;
                }
                span.point{
                    display: block;
                    height: 15px;
                    position: absolute;
                    z-index: 2;
                    @media #{$IE}{
                        width: 64.25px;
                    }
                    @media #{$maxM} {
                        height: 10px;
                    }
                        svg{
                            display: block;
                            height: 100%;
                            width: auto;
                        }
                        &:nth-child(1){
                            bottom: calc(100% + 6px);
                            right: calc(100% + 10px);
                        }
                        &:nth-child(2){
                            bottom: calc(100% + 6px);
                            left: calc(100% + 10px);
                        }
                        &:nth-child(3){
                            top: calc(100% + 6px);
                            right: calc(100% + 10px);
                        }
                        &:nth-child(4){
                            top: calc(100% + 6px);
                            left: calc(100% + 10px);
                        }

                }
            }
            .logomark{
                    position: absolute;
                    width: 37.5%;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);

            }
        }
    }

}
</style>
